import {Injectable} from '@angular/core';
import tinycolor from 'tinycolor2';
import {LoggedUser} from '../common/logged-user.service';

@Injectable({
  providedIn: 'root'
})
export class ThemingService {

  private readonly DEFAULT_PRIMARY_COLOR: string = '#E16100';
  private readonly DEFAULT_SECONDARY_COLOR: string = '#404040';
  private readonly DEFAULT_TERTIARY_COLOR: string = '#B9BABB';

  private readonly docStyle: CSSStyleDeclaration = document.documentElement.style;


  constructor(loggedUser: LoggedUser) {
    loggedUser.userPreferences.subscribe(userData => {
      try {
        const preferences = JSON.parse(userData.preferences);
        this.setPrimaryColor(preferences.primaryColor ?? this.DEFAULT_PRIMARY_COLOR);
        this.setSecondaryColor(preferences.secondaryColor ?? this.DEFAULT_SECONDARY_COLOR);
        this.setTertiaryColor(preferences.tertiaryColor ?? this.DEFAULT_TERTIARY_COLOR);
      } catch (e) {
        this.setPrimaryColor(this.DEFAULT_PRIMARY_COLOR);
        this.setSecondaryColor(this.DEFAULT_SECONDARY_COLOR);
        this.setTertiaryColor(this.DEFAULT_TERTIARY_COLOR);
      }
    });
  }

  public setPrimaryColor(primaryColor: string): void {
    const primary = tinycolor(primaryColor);
    const primaryLight = tinycolor(primaryColor).lighten(40);
    const primaryDark = tinycolor(primaryColor).darken(10);
    const primaryDarker = tinycolor(primaryColor).darken(20);
    this.docStyle.setProperty('--primary-color', primary.toRgbString());
    this.docStyle.setProperty('--primary-light-color', primaryLight.toRgbString());
    this.docStyle.setProperty('--primary-dark-color', primaryDark.toRgbString());
    this.docStyle.setProperty('--primary-darker-color', primaryDarker.toRgbString());
  }

  public setSecondaryColor(secondaryColor: string): void {
    const secondary = tinycolor(secondaryColor);
    const secondaryLight = tinycolor(secondaryColor).lighten(40);
    const secondaryDark = tinycolor(secondaryColor).darken(10);
    const secondaryDarker = tinycolor(secondaryColor).darken(20);
    this.docStyle.setProperty('--secondary-color', secondary.toRgbString());
    this.docStyle.setProperty('--secondary-light-color', secondaryLight.toRgbString());
    this.docStyle.setProperty('--secondary-dark-color', secondaryDark.toRgbString());
    this.docStyle.setProperty('--secondary-darker-color', secondaryDarker.toRgbString());
  }

  public setTertiaryColor(headerColor: string): void {
    const header = tinycolor(headerColor);
    this.docStyle.setProperty('--tertiary-color', header.toRgbString());
  }

}
